import React from 'react'
import { Outlet } from 'react-router-dom';
import Projects from './Projects';
import '../MainBody.css'

function ProjectLayout() {
  return (
    <div className='projects_container'>
      <div className='projects_sidebar'>
        <Projects />
      </div>
      <div className='projects_main'>
        <Outlet />
      </div>
    </div>
  )
}

export default ProjectLayout